const addSliderSteps = (slider, slidedObject) => {
  const sliderStepsParent = slider.find('.slider-nav-steps-container');
  slider.attr('data-is-blocked', 'false');
  const objectsCount = slidedObject.length;
  if (isDesktop() || isTablet()) {
    slidedObject.each(function (index) {
      const navStep = $('<div>', {
        class: 'slider-nav-step',
        id: `nav-step-${index}`,
      });
      if (index == 0) {
        navStep.css('width', isDesktop() ? '3vw' : isTablet() ? '6.25vw' : '13.333vw');
        navStep.toggleClass('active');
      }
      sliderStepsParent.append(navStep);
    });
  } else {
    sliderStepsParent.html(`1 of ${objectsCount}`);
  }
};

const changeSliderStep = (slider, slidedObject, from, to) => {
  const sliderStepsParent = slider.find('.slider-nav-steps-container');
  const navSteps = sliderStepsParent.find('.slider-nav-step');
  const objectsCount = slidedObject.length;
  if (isDesktop() || isTablet()) {
    const prevStep = navSteps.eq(from);
    const nextStep = navSteps.eq(to);
    prevStep.toggleClass('active');
    nextStep.toggleClass('active');
    gsap.to(prevStep, {
      width: () => (isDesktop() ? '0.313vw' : isTablet() ? '0.651vw' : '1.389vw'),
      ease: 'tagInEasing',
      duration: 1,
    });
    gsap.to(nextStep, {
      width: () => (isDesktop() ? '3vw' : isTablet() ? '6.25vw' : '13.333vw'),
      ease: 'tagInEasing',
      duration: 1,
    });
  } else {
    sliderStepsParent.text(`${to + 1} of ${objectsCount}`);
  }
};

const addSliderHover = (slider) => {
  const navBtns = slider.find('.slider-nav-btn');
  navBtns.each(function () {
    const btnIcons = $(this).find('.slider-nav-icon');
    const direction = $(this).hasClass('next') ? 1 : -1;
    $(this).on('mouseenter', () => {
      const isDisabled = $(this).prop('disabled');
      !isDisabled ? arrowAnimation(btnIcons, direction, 1) : false;
    });
    $(this).on('mouseleave', () => {
      arrowAnimation(btnIcons, direction, 0, false);
    });
  });
};

function addSliderInAnimation(slider, isTrigger = true, triggerOffset = 30, isInAnimation = false) {
  const sliderParentSection = slider.closest('section');
  const sliderBtnPrev = slider.find('.slider-nav-btn.prev');
  const sliderBtnNext = slider.find('.slider-nav-btn.next');
  const sliderStepsParent = slider.find('.slider-nav-steps');
  const sliderStepsOverflow = slider.find('.slider-nav-steps-overflow');
  const sliderStepsContainer = slider.find('.slider-nav-steps-container');
  const sliderSteps = slider.find('.slider-nav-step');

  const sliderTL = gsap.timeline({ paused: true });

  if (isDesktop()) {
    sliderTL.add(
      gsap.fromTo(
        sliderSteps,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.4,
          ease: 'opacityInEasing',
        }
      ),
      0.91
    );
  }
  sliderTL.add(
    gsap.fromTo(
      slider,
      { opacity: 0, y: `${1.875 * 1.5 + pxToVw(slider.outerHeight())}vw` },
      {
        y: 0,
        opacity: 1,
        duration: 0.63,
        ease: 'pageInEasing',
      }
    ),
    0
  );
  sliderTL.add(
    gsap.fromTo(
      sliderStepsParent,
      {
        paddingInline: () => `${isDesktop() ? 1.125 : isTablet() ? 4 : 5}vw`,
      },
      {
        paddingInline: () => `${isDesktop() ? 1.875 : isTablet() ? 4 : 8.333}vw`,
        duration: 0.83,
        ease: 'pageInEasing',
      }
    ),
    0.48
  );
  sliderTL.add(
    gsap.fromTo(
      sliderStepsOverflow,
      {
        width: 0,
      },
      {
        width: () => `${pxToVw(sliderStepsContainer.outerWidth())}vw`,
        duration: 0.83,
        ease: 'pageInEasing',
      }
    ),
    0.48
  );
  sliderTL.add(
    gsap.fromTo(
      sliderBtnNext,
      {
        left: '50%',
      },
      {
        left: () => `calc(100% + ${pxToVw(sliderBtnPrev.outerWidth()) / 2}vw)`,
        duration: 0.83,
        ease: 'pageInEasing',
      }
    ),
    0.48
  );
  sliderTL.add(
    gsap.fromTo(
      sliderBtnPrev,
      {
        left: '50%',
      },
      {
        left: () => `calc(0% - ${pxToVw(sliderBtnPrev.outerWidth()) / 2}vw)`,
        duration: 0.83,
        ease: 'pageInEasing',
      }
    ),
    0.48
  );

  let sliderTriggerTL = gsap.timeline({ paused: true });

  sliderTL.getChildren().forEach((tween) => {
    sliderTriggerTL.add(gsap.to(tween._targets, tween.vars), tween.startTime());
  });

  $(window).on('deviceChange', function () {
    const activeSlideWidth = isDesktop() ? '3vw' : isTablet() ? '6.25vw' : '13.333vw';
    gsap.set(sliderSteps.filter('.active'), { width: activeSlideWidth });
    gsap.set(sliderStepsParent, { paddingInline: () => `${isDesktop() ? 1.875 : isTablet() ? 4 : 8.333}vw` });
    gsap.set(sliderStepsOverflow, { width: () => `${pxToVw(sliderStepsContainer.outerWidth())}vw` });
    gsap.set(sliderBtnNext, { left: () => `calc(100% + ${pxToVw(sliderBtnPrev.outerWidth()) / 2}vw)` });
    gsap.set(sliderBtnPrev, { left: () => `calc(0% - ${pxToVw(sliderBtnPrev.outerWidth()) / 2}vw)` });
    sliderTriggerTL.clear();
    sliderTL.getChildren().forEach((tween) => {
      sliderTriggerTL.add(gsap.to(tween._targets, tween.vars), tween.startTime());
    });
    sliderTriggerTL.progress(sliderTL.progress());
  });

  if (isInAnimation) {
    ScrollTrigger.create({
      trigger: slider,
      start: `top-=350% bottom`,
      end: 'bottom bottom',
      once: true,
      onEnter: () => {
        sliderTL.play();
      },
    });
  }

  sliderTL.eventCallback('onComplete', () => {
    if (isTrigger) {
      ScrollTrigger.create({
        trigger: sliderParentSection,
        start: `bottom top+=${triggerOffset}%`,
        end: 'bottom top',
        onEnter: () => {
          sliderTriggerTL.progress(1);
          sliderTriggerTL.reverse();
        },
        onLeaveBack: () => {
          sliderTriggerTL.play();
        },
      });
    }
  });

  return sliderTL;
}

const addStepAnimation = (slider, slidedObject, objectAnimationCallback, additionalSliderObject = undefined) => {
  const navBtns = slider.find('.slider-nav-btn');
  addSliderSteps(slider, slidedObject);
  addSliderHover(slider);
  const min = 0;
  const max = slidedObject.length - 1;
  let currentStep = 0;
  navBtns.on('click', function () {
    const isBlocked = slider.attr('data-is-blocked');
    if (isBlocked == 'both') {
      return;
    }

    slider.attr('data-is-blocked', 'both');
    const direction = $(this).hasClass('next') ? 1 : -1;
    const to = currentStep + direction;

    navBtns.prop('disabled', false);
    if (to == min) {
      navBtns.filter('.prev').prop('disabled', true);
    } else if (to == max) {
      navBtns.filter('.next').prop('disabled', true);
    }

    objectAnimationCallback(slider, slidedObject, direction, currentStep, to, additionalSliderObject);
    changeSliderStep(slider, slidedObject, currentStep, to);
    currentStep = to;
  });
};
